// ============================================================================
// Hook TanStack Query — recherche globale (GEST-SEARCH-GLOBAL)
// ============================================================================
// GET /api/search?q= — enabled seulement si q.trim().length >= 2.
// Debounce ~250 ms cote appelant (SearchPalette) ; ici keepPreviousData pour
// eviter le flash vide pendant la frappe. Autorite = serveur (RLS + gardes a3).

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export type SearchResultType = 'person' | 'team' | 'posting';

export interface SearchResult {
  type: SearchResultType;
  id: string;
  label: string;
  sublabel: string | null;
  href: string;
}

export interface SearchResponse {
  results: SearchResult[];
}

const SEARCH_KEY = ['gest', 'search'] as const;

/** Longueur minimale du terme (miroir Zod serveur). Exporte pour les tests. */
export const SEARCH_MIN_CHARS = 2;

export function useGlobalSearch(q: string) {
  const trimmed = q.trim();
  const enabled = trimmed.length >= SEARCH_MIN_CHARS;

  return useQuery({
    queryKey: [...SEARCH_KEY, trimmed] as const,
    queryFn: () => api.get<SearchResponse>(`/api/search?q=${encodeURIComponent(trimmed)}`),
    enabled,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
